import { takeEvery, call, put } from 'redux-saga/effects'
import { SubmissionError } from 'redux-form'

import { updateLogin, errorLogin, LOGIN_POST } from 'actions/login'
import { updateUserData } from 'actions/general'
import { logInteraction } from 'util/log-interaction'

function _postLogin({ create }, logError) {
  return function*(action) {
    try {
      logInteraction('login')
      const accountEndpoint = '/auth'

      const { values, queryParamReturnTo } = action.payload

      const loginResult = yield call(create, accountEndpoint, values)
      const { orgslug } = loginResult

      yield put(
        updateLogin({
          data: loginResult,
        })
      )
      yield put(
        updateUserData({
          orgslug,
          username: values.username,
          portalUrl: queryParamReturnTo || loginResult.returnTo,
        })
      )

      yield call(action.payload.resolve)
    } catch (err) {
      yield call(logError, err)

      const data =
        err.status === 400 && err.responseText
          ? JSON.parse(err.responseText)
          : null
      const errorData = data.msg

      if (errorData) {
        yield call(
          action.payload.reject,
          new SubmissionError({ _error: errorData })
        )
      } else {
        yield call(action.payload.reject)
      }

      yield put(
        errorLogin({
          error: true,
          data: data,
        })
      )
    }
  }
}

export const Test = {
  _postLogin,
}

// Watchers
// ---------------------------------------------------------------------------
export function* watchPostLogin(api, error) {
  yield takeEvery(LOGIN_POST, _postLogin(api, error))
}
